'use strict';
import angular from 'angular';
import $ from 'jquery';

angular.module('notifications.ctrls', [])
    .controller('NotificationsController', NotificationsController);

NotificationsController.$inject = ['$rootScope', '$scope', '$timeout', 'ClusterService', 'DateRangeService', 'NotificationsService', '$ioAlert', '$modal', '$state', '$stateParams', '$confirm', 'ModalService'];

function NotificationsController($rs, $scope, $timeout, ClusterService, DateRangeService, NotificationsService, $ioAlert, $modal, $state, $stateParams, $confirm, ModalService) {
    $scope.notifications = [];
    $scope.isCurrent = true;
    $scope.loading = true;
    $scope.checkedIndex = [];
    $scope.isViewDisabled = false;
    $scope.sortReverse = true;
    $scope.sortType = 'notification_date';
    $scope.pageObj = {
        perPageOptions: [10, 25, 50, 100],
        perPage: 50,
        currentPage: 1,
        totalCount: 0,
        startIndex: 1,
        endIndex: 1,
        maxSize: 2,
    };

    var initDataTableOptions = function() {
        $scope.dtOptions = {};
        $scope.dtOptions.data = $scope.notifications;
        $scope.dtOptions.columns = [
            { field: 'id', label: '', format: 'custom' },
            { field: 'type', label: 'Type' },
            { field: 'subject', label: 'Subject', format: 'custom', className: 'link-cell' },
            { field: 'actions', label: 'Actions', is_primary_key: true, format: 'custom' }
        ];
        $scope.dtOptions.entityName = 'notifications';
        $scope.dtOptions.itemName = 'notification';
        $scope.dtOptions.iActions = 2;
        $scope.dtOptions.customRenders = {};
        $scope.dtOptions.customRenders['id'] = function(data, type, full) {
            return '<input class="action-checked" type="checkbox"></input>';
        };
        $scope.dtOptions.customRenders['subject'] = function(data, type, full) {
            return '<a class="order-link">' + full.name + '</a>';
        };
        $scope.dtOptions.customRenders['actions'] = function(data, type, full) {
            let elem = '';
            if (full.object_type_id == NotificationsService.NOTIFICATION_OBJECT_TYPE_ORDER) {
                elem = '<a class="action action-link has-tooltip" title="Navigate To Page" href="#/items/viewOrder/' + full.object_id + '"><span class="icon fa fa-external-link"></span></a>';
            } else if (full.object_type_id == NotificationsService.NOTIFICATION_OBJECT_TYPE_LINE_ITEM) {
                elem = '<a class="action action-link has-tooltip" title="Navigate To Page" href="#/items/viewLineItem/' + full.object_id + '"><span class="icon fa fa-external-link"></span></a>';
            } else if (full.object_type_id == NotificationsService.NOTIFICATION_OBJECT_TYPE_TASK) {
                elem = '<a class="action action-link has-tooltip" title="Navigate To Page" href="#/items/myTasks/' + full.object_id + '"><span class="icon fa fa-external-link"></span></a>';
            }
            return elem;
        };
        $scope.dtOptions.fnCreatedRow = function(row, raw, id) {
            $(row).find('a').each(function() {
                let $cell = $(this).closest('td');
                if ($cell.hasClass('link-cell')) {
                    $cell.click(function() {
                        $scope.viewNotification(id);
                    });
                }
            });
            $(row).find('input.action-checked').bind('change', function() {
                $scope.notifications[id].checked = !$scope.notifications[id].checked;
                $scope.showButtons = $scope.checkedIndex.length ? true : false;

                $timeout(function() {
                    $scope.$apply();
                });

                $scope.checkSelected($scope.notifications[id].id);
            });
            $.core.main.tooltip($(row));
        };
    };

    $scope.navigateToPage = function(notification) {
        $scope.open(notification);
    };

    $scope.selectedNotification = function(index) {
        $scope.showButtons = $scope.checkedIndex.length ? true : false;
        $scope.checkSelected($scope.notifications[index].id);
    };

    var classifyNotifications = function() {
        for (let i = 0; i < $scope.notifications.length; i++) {
            if ($scope.notifications[i].object_type_id == NotificationsService.NOTIFICATION_OBJECT_TYPE_ORDER) {
                $scope.notifications[i].href = '"viewOrder({id:' + $scope.notifications[i].object_id + '}"';
            } else if ($scope.notifications[i].object_type_id == NotificationsService.NOTIFICATION_OBJECT_TYPE_LINE_ITEM) {
                $scope.notifications[i].href = '"viewLineItem({lineItemId:' + $scope.notifications[i].object_id + '}"';
            } else if ($scope.notifications[i].object_type_id == NotificationsService.NOTIFICATION_OBJECT_TYPE_TASK) {
                $scope.notifications[i].href = '"myTasksView({taskId:' + $scope.notifications[i].object_id + '}"';
            }
        }
    };

    var getCurrentNotifications = function() {
        const params = {
            currentPage: $scope.pageObj.currentPage,
            perPage: $scope.pageObj.perPage,
            showArchived : '0',
        };
        $rs.loadingInProgress = true;
        NotificationsService.getNotificationsWithPagination(params).then(function(success) {
            $scope.notifications = success.notifications;
            classifyNotifications();
            initDataTableOptions();
            $scope.notificationsActive = true;
            $scope.loading = false;
            $rs.loadingInProgress = false;
        }, function(error) {
            $rs.loadingInProgress = false;
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    var getArchivedNotifications = function() {
        const params = {
            currentPage: $scope.pageObj.currentPage,
            perPage: $scope.pageObj.perPage,
            showArchived : '1',
        };
        $rs.loadingInProgress = true;
        NotificationsService.getNotificationsWithPagination(params).then(function(success) {
            $scope.notifications = success.notifications;
            classifyNotifications();
            initDataTableOptions();
            $scope.notificationsActive = true;
            $scope.loading = false;
            $rs.loadingInProgress = false;
        }, function(error) {
            $rs.loadingInProgress = false;
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    var archive = function(notification) {
        NotificationsService.archive(notification.id).then(function(success) {
            if (NotificationsService.notification.status_id == NotificationsService.STATUS_NOTIFICATION_ARCHIVED) {
                $ioAlert.show('', 'Notification ' + notification.id + ' successfully archived', 'success');
                $scope.showCurrentNotifications();
            } else {
                $ioAlert.show('Error!', 'Failed to archive notification ' + notification.id, 'error');
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    function showNotificationsModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, { data: data }));
    }

    $scope.viewNotification = function(index) {
        let notification = $scope.notifications[index];
        notification.archived = (notification.status_id == NotificationsService.STATUS_NOTIFICATION_ARCHIVED);
        showNotificationsModal('notifications', notification).result.then(function(action) {
            if (action == 'open') {
                $scope.open($scope.notifications[index]);
            } else if (action == 'archive') {
                archive($scope.notifications[index]);
            }
        }, function() {});
    };

    $scope.deleteNotification = function() {
        if ($scope.checkedIndex.length > 0) {
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete these notifications?'
            }).then(function() {
                NotificationsService.deleteMultipleNotifications($scope.checkedIndex).then(function(data) {
                    if (data.notificationIds) {
                        $ioAlert.show('', 'Notifications successfully deleted', 'success');
                        if ($scope.isCurrent) {
                            $scope.showCurrentNotifications();
                        } else {
                            $scope.showArchivedNotifications();
                        }
                    } else {
                        $ioAlert.show('Error!', 'Failed to delete notifications', 'error');
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            }, function() {
                _.each($scope.notifications, function (notification) {
                    notification.checked = false;
                });
                $scope.checkedIndex = [];
                $scope.showButtons = false;
                $scope.checkAll = false;
            });
        }
    };

    $scope.archiveNotifications = function() {
        if ($scope.checkedIndex.length > 0) {
            NotificationsService.archiveMultipleNotifications($scope.checkedIndex).then(function(data) {
                if (data.notificationIds) {
                    $ioAlert.show('', 'Notifications successfully archived', 'success');
                    if ($scope.isCurrent) {
                        $scope.showCurrentNotifications();
                    }
                } else {
                    $ioAlert.show('Error!', 'Failed to archive notifications', 'error');
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }
    };

    $scope.showCurrentNotifications = function() {
        _.each($scope.notifications, function (notification) {
            notification.checked = false;
        });
        $scope.checkAll = false;
        $scope.checkedIndex = [];
        $scope.showButtons = false;
        $scope.isCurrent = true;

        $timeout(function() {
            $scope.notificationsActive = false;
            $scope.$apply();
        });

        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching current notifications";

        const showArchived = '0';
        NotificationsService.getNumberOfNotifications(showArchived).then(function(data) {
            if (!isNaN(data.total)) {
                $scope.pageObj.totalCount = data.total;
                getCurrentNotifications();
            } else {
                $rs.loadingInProgress = false;
                $ioAlert.show('Error!', 'Failed to get number of notifications', 'error');
            }
        }, function(error) {
            $rs.loadingInProgress = false;
            $ioAlert.show('Error!', error, 'error');
        });
    };

    $scope.showArchivedNotifications = function() {
        _.each($scope.notifications, function (notification) {
            notification.checked = false;
        });
        $scope.checkAll = false;
        $scope.checkedIndex = [];
        $scope.showButtons = false;
        $scope.isCurrent = false;

        $timeout(function() {
            $scope.notificationsActive = false;
            $scope.$apply();
        });

        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching archived notifications";

        const showArchived = '1';
        NotificationsService.getNumberOfNotifications(showArchived).then(function(data) {
            if (!isNaN(data.total)) {
                $scope.pageObj.totalCount = data.total;
                getArchivedNotifications();
            } else {
                $rs.loadingInProgress = false;
                $ioAlert.show('Error!', 'Failed to get number of notifications', 'error');
            }
        }, function(error) {
            $rs.loadingInProgress = false;
            $ioAlert.show('Error!', error, 'error');
        });
    };

    $scope.selectAll = function() {
        $('input.action-checked').each(function() {
            $scope.checkAll ? $(this).prop('checked', true) : $(this).prop('checked', false);
        });
        for (let i = 0, len = $scope.notifications.length; i < len; i++) {
            if ($scope.checkAll) {
                $scope.notifications[i].checked = true;
                $scope.checkedIndex.push($scope.notifications[i].id);
                $scope.showButtons = true;
            } else {
                $scope.notifications[i].checked = false;
                $scope.checkedIndex = [];
                $scope.showButtons = false;
            }
        }
    };

    $scope.checkSelected = function(id) {
        let elePos = $scope.checkedIndex.indexOf(id);
        if (elePos >= 0) {
            $scope.checkedIndex.splice(elePos, 1);
            $scope.checkAll = false;
            $scope.showButtons = ($scope.checkedIndex.length > 0);
        } else {
            $scope.showButtons = true;
            $scope.checkedIndex.push(id);
            if ($scope.checkedIndex.length == $scope.notifications.length) {
                $scope.checkAll = true;
            }
        }
    };

    $scope.open = function(index) {
        if (!$scope.isViewDisabled) {
            let path = "";
            let params = {};


            if (index.object_type_id == NotificationsService.NOTIFICATION_OBJECT_TYPE_ORDER) {
                path = "viewOrder";
                params = { id: index.object_id };
            } else if (index.object_type_id == NotificationsService.NOTIFICATION_OBJECT_TYPE_LINE_ITEM) {
                path = "viewLineItem";
                params = { lineItemId: index.object_id };
            } else if (index.object_type_id == NotificationsService.NOTIFICATION_OBJECT_TYPE_TASK) {
                path = "myTasksView";
                params = { taskId: index.object_id };
            } else if (index.object_type_id == NotificationsService.NOTIFICATION_OBJECT_TYPE_COMMENT) {
                if (index.table_name == "order") {
                    path = "viewOrder";
                    params = { id: index.table_row_id };
                } else if (index.table_name == "line_item") {
                    path = "viewLineItem";
                    params = { lineItemId: index.table_row_id };
                }
            } else {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again.', 'error');
            }

            $state.go(path, params);
        }
    };

    $scope.getOnePageNotifications = function() {
        if ($scope.isCurrent) {
            getCurrentNotifications();
        } else {
            getArchivedNotifications();
        }
    };

    var init = function() {
        ClusterService.initCluster($rs.userRole, 'hidden');
        DateRangeService.init();
        if ($stateParams.archived == "true") {
            $scope.showArchivedNotifications();
        } else {
            $scope.showCurrentNotifications();
        }

        if ($rs.userRole && ($rs.userRole.permissions == 'vendor' || $rs.userRole.permissions == 'vendor-restricted')) {
            $scope.isViewDisabled = true;
        } else {
            $scope.isViewDisabled = false;
        }
    };

    init();
}